import authReducer from "@funded-here-interface/common/src/features/auth/authSlice_Investor";
import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { persistStore, persistReducer, type PersistedState } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";

import disBankSlice from "./features/distributor/bank";
import disBizSlice from "./features/distributor/biz";
import bankSliceInd from "./features/indinvestor/bankSliceInd";
import profSlice from "./features/indinvestor/profSlice";
import bankSlice from "./features/institutionalInvestor/bankSlice";
import bizSlice from "./features/institutionalInvestor/bizSlice";
import repSlice from "./features/institutionalInvestor/repSlice";
import BorbankSlice from "./features/merchant/bankSlice";
import bizBorSlice from "./features/merchant/biz";
import docBorrowerSlice from "./features/merchant/doc";
import MerchantSlice from "./features/merchant/MerchantSlice/MerchantSlice";
import PaymentTrackingSlice from "./features/merchant/MerchantSlice/PaymentTrackingSlice";
import BorrepSlice from "./features/merchant/rep";
import docSlice from "./features/registration/docSlice";
import bulkSlice from "./features/sku/bulkSlice";

declare const __APP_VERSION__: string;

const hashStringToNumber = (s: string): number => {
  let h = 0;
  for (let i = 0; i < s.length; i++) {
    h = ((h << 5) - h + s.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
};

const persistConfig = {
  key: "root",
  storage: storageSession,
  whitelist: ["auth", "biz", "prof"], // Add other reducers you want to persist here
  version: hashStringToNumber(__APP_VERSION__),
  migrate: async (state: PersistedState, currentVersion: number): Promise<PersistedState> => {
    if (!state) return undefined;
    if (state._persist.version === currentVersion) return state;
    // Preserve auth so user stays logged in; drop biz and prof to avoid stale shapes.
    const { auth } = state as PersistedState & { auth?: unknown };
    return { auth, _persist: state._persist } as PersistedState;
  },
};

const persistedReducer = persistReducer(
  persistConfig,
  combineReducers({
    auth: authReducer,
    biz: bizSlice,
    rep: repSlice,
    bank: bankSlice,
    doc: docSlice,
    disBiz: disBizSlice,
    borBiz: bizBorSlice,
    BorBank: BorbankSlice,
    disBank: disBankSlice,
    Borrep: BorrepSlice,
    bordoc: docBorrowerSlice,
    prof: profSlice,
    bankInd: bankSliceInd,
    bulk: bulkSlice,
    merchantReducer: MerchantSlice,
    paymentReducer: PaymentTrackingSlice,
  }),
);

const store = configureStore({
  reducer: persistedReducer,
});
const persistor = persistStore(store);

export { store, persistor };
export type RootState = ReturnType<typeof store.getState>;
